import { STATS_MARQUEE } from "@/lib/data";

export default function StatsMarquee() {
  const items = [...STATS_MARQUEE, ...STATS_MARQUEE];
  return (
    <section
      data-testid="stats-marquee"
      className="relative border-y border-ink-600 bg-ink-900 overflow-hidden py-6 marquee-mask"
    >
      <div className="flex animate-marquee whitespace-nowrap gap-12">
        {items.map((txt, i) => (
          <div
            key={i}
            className="flex items-center gap-12 font-display text-2xl md:text-4xl font-semibold tracking-tight"
          >
            <span className="text-white">{txt}</span>
            <span className="text-amber text-3xl">✦</span>
          </div>
        ))}
      </div>
    </section>
  );
}
